export const languageDictionary = {
  ca: 'Català',
  'en-GB': 'English',
  es: 'Español',
  eu: 'Euskera',
  fr: 'Français',
  'fr-be': 'Français',
  'nl-be': 'Flemish',
};
